import { useApp } from './context/AppContext';
import FileUpload from './components/FileUpload/FileUpload';
import PDFViewer from './components/PDFViewer/PDFViewer';
import PDFSplitter from './components/PDFSplitter/PDFSplitter';
import PDFSigner from './components/PDFSigner/PDFSigner';
import FormFiller from './components/FormFiller/FormFiller';
import PDFMerger from './components/PDFMerger/PDFMerger';
import PDFConverter from './components/PDFConverter/PDFConverter';
import PDFRedactor from './components/PDFRedactor/PDFRedactor';
import Settings from './components/Settings/Settings';
import Sidebar from './components/Sidebar/Sidebar';
import Footer from './components/Footer/Footer';
import FAQ from './components/pages/FAQ';
import Terms from './components/pages/Terms';
import Privacy from './components/pages/Privacy';
import Contact from './components/pages/Contact';
import './App.css';

const Notifications = () => {
  const { notifications, removeNotification } = useApp();

  if (notifications.length === 0) return null;

  return (
    <div className="notifications-container">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={`notification ${notification.type}`}
          onClick={() => removeNotification(notification.id)}
        >
          <span className="notification-message">{notification.message}</span>
          <button className="notification-close">×</button>
        </div>
      ))}
    </div>
  );
};

function App() {
  const { currentView, setCurrentView, uploadedFiles, fileSignatures, clearAllFiles } = useApp();

  const handleUploadNew = () => {
    // Check if there are files or signatures that would be lost
    const totalSignatures = Object.values(fileSignatures).reduce(
      (sum, sigs) => sum + (sigs?.length || 0),
      0
    );

    if (uploadedFiles.length > 0 || totalSignatures > 0) {
      let message = 'You have ';
      const parts = [];

      if (uploadedFiles.length > 0) {
        parts.push(`${uploadedFiles.length} uploaded file${uploadedFiles.length !== 1 ? 's' : ''}`);
      }
      if (totalSignatures > 0) {
        parts.push(`${totalSignatures} signature${totalSignatures !== 1 ? 's' : ''}`);
      }

      message += parts.join(' and ') + ' that will be lost. Continue?';

      if (!confirm(message)) {
        return;
      }

      // Clear all files and signatures before going to upload
      clearAllFiles();
    } else {
      setCurrentView('upload');
    }
  };

  const isStaticPage = ['faq', 'terms', 'privacy', 'contact'].includes(currentView);

  const renderView = () => {
    switch (currentView) {
      case 'upload':
        return <FileUpload />;
      case 'view':
        return <PDFViewer />;
      case 'split':
        return <PDFSplitter />;
      case 'sign':
        return <PDFSigner />;
      case 'form':
        return <FormFiller />;
      case 'merge':
        return <PDFMerger />;
      case 'convert':
        return <PDFConverter />;
      case 'redact':
        return <PDFRedactor />;
      case 'settings':
        return <Settings />;
      case 'faq':
        return <FAQ />;
      case 'terms':
        return <Terms />;
      case 'privacy':
        return <Privacy />;
      case 'contact':
        return <Contact />;
      default:
        return <FileUpload />;
    }
  };

  return (
    <div className="app">
      {uploadedFiles.length > 0 && currentView !== 'upload' && currentView !== 'settings' && !isStaticPage && (
        <Sidebar />
      )}

      <div className="main-content">
        {currentView !== 'upload' && !isStaticPage && (
          <header className="app-header">
            <div className="header-left">
              <h1 className="app-title">GoSplitPDF</h1>
            </div>
            <div className="header-right">
              <button
                className="btn btn-ghost"
                onClick={handleUploadNew}
              >
                Upload New
              </button>
              <button
                className="btn btn-ghost"
                onClick={() => setCurrentView('settings')}
              >
                ⚙️ Settings
              </button>
            </div>
          </header>
        )}

        <div className="view-container">
          {renderView()}
        </div>

        <Footer />
      </div>

      <Notifications />
    </div>
  );
}

export default App;
